import './branding.scss';
import './App.scss';
import {BrowserRouter} from "react-router-dom";
import routes from "./routes";
import {loadDevMessages, loadErrorMessages} from "@apollo/client/dev";
import ReactGA from "react-ga4";
import Header from "./layout/Header";
import React from "react";
import Footer from "./layout/Footer";

// if () {  // Adds messages only in a dev environment
if (process.env.NODE_ENV !== 'production') {
  loadDevMessages();
  loadErrorMessages();
}

if (process.env.NODE_ENV === 'production') {
  ReactGA.initialize(process.env.REACT_APP_GA4_ID);
}

const App = () => {
  return (
    <BrowserRouter>
      <div className='min-vh-100 d-flex flex-column'>
        <Header />
        {routes}
        <Footer />
      </div>
    </BrowserRouter>
  );
}

export default App;
